export class FetchNewsList {
  static readonly type = '[News] Fetch news list';
}

export class GetNewsById {
  static readonly type = '[News] Get news by ID';

  constructor(public id: number) {}
}